<template>
  <div class="loader-wrapper">
    <content-loader
      :width="240"
      :height="100"
      :speed="1.5"
      primaryColor="#c3c3c3"
      secondaryColor="#F8F7FA"
      :animate="true"
    >
      <circle r="22" cy="42" cx="47"/>
      <rect rx="3" height="9" width="125" y="28" x="86"/>
      <rect rx="3" height="8" width="60" y="51" x="86"/>
      <rect rx="3" height="8" width="95" y="81" x="86"/>
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>

<style scoped lang="scss">
.loader-wrapper {
  width: 240px;
}
</style>
